import { render, staticRenderFns } from "./Mdmask.vue?vue&type=template&id=457711ef&scoped=true&"
import script from "./Mdmask.vue?vue&type=script&lang=js&"
export * from "./Mdmask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457711ef",
  null
  
)

export default component.exports